module.exports = {
    namespace: 'skills',
    da: require('./da'),
    en: require('./en'),
};



// WEBPACK FOOTER //
// ./src/taskflex/skills/locales/index.js